import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
    overflow: "auto",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    color: "#000",
  },
  pageSubHeading: {
    fontSize: theme.typography.pxToRem(17),
    color: "#000",
    paddingBottom: "10px",
  },
  outer: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px",
  },
  checkButton: {
    color: "#ffffff",
    backgroundColor: "#72CA00",
    padding: "8px",
    width: "100%",
  },
  previewBox: {
    padding: "10px",
    "& table": {
      borderCollapse: "collapse",
      textAlign: "center",
      width: "100%",
      marginTop: "10px",
      fontSize: "14px",
    },
    "& td": {
      border: "1px solid black",
      padding: "10px",
    },
    // "& tr:nth-child(even)": { backgroundColor: "#f2f2f2" },
    "& tr:nth-child(1)": { fontWeight: 700 },
  },
}));
